import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getCollections ({ commit, dispatch }) {
    try {
      const { data } = await directus.getItems('directus_collections')
      const value = data.map(item => {
        return {
          value: item.collection,
          text: item.collection
        }
      })
      commit('setAttr', {
        name: 'collections',
        value
      })
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
